'use client';

import { __makeTemplateObject } from '../_virtual/_tslib.js';
import styled from 'styled-components';

var TravelLineContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    border-left: 1px solid #d9d5d5;\n\n    > div {\n        position: relative;\n\n        > div:nth-child(1) {\n            position: absolute;\n            top: ", "px;\n            left: -", "px;\n        }\n\n        > div:nth-child(2) {\n            padding-left: ", "px;\n        }\n    }\n"], ["\n    border-left: 1px solid #d9d5d5;\n\n    > div {\n        position: relative;\n\n        > div:nth-child(1) {\n            position: absolute;\n            top: ", "px;\n            left: -", "px;\n        }\n\n        > div:nth-child(2) {\n            padding-left: ", "px;\n        }\n    }\n"])), function (_a) {
    var positionTopIcon = _a.positionTopIcon;
    return positionTopIcon;
}, function (_a) {
    var widthIcon = _a.widthIcon;
    return widthIcon / 2;
}, function (_a) {
    var gap = _a.gap;
    return gap;
});
var templateObject_1;

export { TravelLineContainer };
//# sourceMappingURL=styles.js.map
